import { BaseEntity, Transform, toDate } from './base';

export class GasPrice extends BaseEntity {
  fuelType: string;
  price: string;

  @Transform(toDate)
  postedAt: Date;
}
